'use client'

import { HomeFaqList } from '@/constants/faq'

import { Col, Container, Row } from 'react-bootstrap'

import AccordionSimple from '@/components/accordion/AccordionSimple'

function HomeFaq() {
  return (
    <Container className="pt-md-5 pb-5 home-faqs">
      <h2 className="text-center pb-5 pt-5 alrajhi-black fw-bold fs-26">
        Frequently-asked questions (FAQ) about Islamic banking in Malaysia
      </h2>
      <Row>
        <Col md={2}> </Col>
        <Col md={8}>
          <AccordionSimple
            data={HomeFaqList}
            faqSchema
            toggleButton={false}
            viewAllButton={false}
          />
        </Col>
        <Col md={2}> </Col>
      </Row>
    </Container>
  )
}

export default HomeFaq
